import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { RdsIconsModule } from '@rds/angular-components';

@Component({
  selector: 'inexp-offering-use-cases',
  imports: [RdsIconsModule],
  templateUrl: './offering-use-cases.component.html',
  styleUrl: './offering-use-cases.component.scss',
})
export class OfferingUseCasesComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  router = inject(Router);
  useCases = input<any[]>();

}
